import { Icon } from "@/ds";

import { ConflictCard } from "../conflict-card";
import type { ConflictBadgeViewModel } from "./types-conflict-badge";
import styles from "./conflict-badge.module.scss";

export function ConflictBadgeView({
  label,
  groups,
  comCard,
  tooltip,
  anchorProps,
  card,
}: ConflictBadgeViewModel) {
  return (
    <>
      <span
        className={styles.badge}
        data-gantt-tip={!comCard && tooltip ? true : undefined}
        data-pr-tooltip={comCard ? undefined : tooltip}
        data-testid="gantt-conflict-badge"
        {...anchorProps}
      >
        <Icon name="exclamation-triangle" size={10.5} />
        {label}
      </span>
      {comCard ? <ConflictCard groups={groups} tratado={false} card={card} /> : null}
    </>
  );
}
